import { usePathname } from 'next/navigation'

import { useAppContext } from '@/client/context/app'
import { useQuery } from '@/client/context/query'

export default function useIsQueryAvailable(): boolean {
  // Some components and static builds require access to query,
  // which is unavailable during tests and during 404 page static build
  const query = useQuery()
  const pathname = usePathname()
  const appContext = useAppContext()

  return !(
    query == null ||
    (query.tape.count === 0 && !appContext.prepass) ||
    pathname == null ||
    pathname === '/_error'
  )
}
